module.exports = __webpack_public_path__ + "static/media/26.8524c5ed.png";